// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"207":"a3466cdb","367":"a3466cdb","484":"a3466cdb","528":"a3466cdb","872":"25edd82a","947":"a3466cdb"}[chunkId] + ".chunk.css";
};